import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import clsx from 'clsx';
import { useMemo } from 'react';

import { TableCellName } from '~components/generic/table/TableCellName';
import { TableCellPlaceholder } from '~components/generic/table/TableCellPlaceholder';
import useLabels from '~hooks/useLabels';
import styles from '~components/generic/table/Table.module.css';

export const TablePlaceholder = () => {
  const data = useMemo(() => [{ id: 1 }, { id: 2 }, { id: 3 }], []);

  const {
    tableHeaderPermissionsRole,
    tableHeaderPermissionsView,
    tableHeaderPermissionsUpdate,
    tableHeaderPermissionsCreate,
    tableHeaderPermissionsDelete,
    tableHeaderPermissionsViewDraft,
    tableHeaderPermissionsPublish,
    tableHeaderPermissionsSetGrants,
  } = useLabels([
    'tableHeaderPermissionsRole',
    'tableHeaderPermissionsView',
    'tableHeaderPermissionsUpdate',
    'tableHeaderPermissionsCreate',
    'tableHeaderPermissionsDelete',
    'tableHeaderPermissionsViewDraft',
    'tableHeaderPermissionsPublish',
    'tableHeaderPermissionsSetGrants',
  ]);

  const columns = [
    {
      header: () => <span>{tableHeaderPermissionsRole}</span>,
      accessorKey: 'name',
      cell: ({ getValue, row }) => <TableCellName value={getValue()} row={row} />,
    },
    {
      header: () => <span>{tableHeaderPermissionsView}</span>,
      accessorKey: 'view',
      cell: () => <TableCellPlaceholder />,
    },
    {
      header: () => <span>{tableHeaderPermissionsUpdate}</span>,
      accessorKey: 'update',
      cell: () => <TableCellPlaceholder />,
    },
    {
      header: () => <span>{tableHeaderPermissionsCreate}</span>,
      accessorKey: 'create',
      cell: () => <TableCellPlaceholder />,
    },
    {
      header: () => <span>{tableHeaderPermissionsDelete}</span>,
      accessorKey: 'delete',
      cell: () => <TableCellPlaceholder />,
    },
    {
      header: () => <span>{tableHeaderPermissionsViewDraft}</span>,
      accessorKey: 'view_draft',
      cell: () => <TableCellPlaceholder />,
    },
    {
      header: () => <span>{tableHeaderPermissionsPublish}</span>,
      accessorKey: 'publish',
      cell: () => <TableCellPlaceholder />,
    },
    {
      header: () => <span>{tableHeaderPermissionsSetGrants}</span>,
      accessorKey: 'set_grants',
      cell: () => <TableCellPlaceholder />,
    },
  ];
  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className={styles.container}>
      <table className={styles.table}>
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header, index) => {
                return (
                  <th key={header.id} colSpan={header.colSpan} className={clsx(styles.th, index === 0 && styles.th30)}>
                    {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>

        <tbody>
          {table.getRowModel().rows.map(row => (
            <tr key={row.id} className={styles.tr}>
              {row.getVisibleCells().map(cell => (
                <td key={cell.id} className={styles.td}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
